import  React , { useState } from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import { BASE_URL } from '../../constants/Constants';

export default function Googlerecaptcha() {
    const [verified, setVerified] = React.useState(false);
    const [token, setToken] = useState("");
    const siteKey = "6LfOsfgrAAAAALPzAxoes0M3MMDL8iju1RHUxAO_";

    const handleVerify = (tokenValue) => {
        setToken(tokenValue);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!token) {
            alert("Please complete the captcha first.");
            return;
        }

        try {
            const res = await fetch(`${BASE_URL}/auth/verify-recaptcha`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
     

      const data = await res.json();
       console.log("data", data)
            if (data.success) {
                setVerified(true);
                alert("✅ CAPTCHA verified successfully!");
            } else {
                alert("❌ CAPTCHA verification failed!");
            }
        } catch (err) {
            console.error(err);
            alert("Error verifying CAPTCHA");
        }
    };


    return (
        <div style={{ padding: 24 }}>
            <h2>Google recaptcha v2 </h2>
            <form onSubmit={handleSubmit}>
                <ReCAPTCHA sitekey={siteKey} onChange={handleVerify} />
                <br />
                <button
                    type="submit"
                    style={{
                        padding: "8px 16px",
                        background: verified ? "#4CAF50" : "#999",
                        color: "white",
                        border: "none",
                        borderRadius: 5,
                        cursor: verified ? "pointer" : "not-allowed",
                    }}
                >
                    Submit
                </button>
            </form>
             {verified && <p style={{ color: "green" }}>Verification successful!</p>}
        </div>
    )
}
